import React, { Component, } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Button, Modal, Input, Icon as AntdIcon, Upload, Empty, notification, Carousel } from 'antd';
import { isEmpty, isEqual, isArray } from 'underscore';

import styles from './styles';

import ImageCapture from '../../../../../modals/ImageCapture';
import * as customerActions from '../../../../../../core/customer/customerActions';

class UploadModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fileList: [],
            isInnerModelActive: false,
            title: null,
            orderItemId: props.orderItemId || null,
        };

        this.webcamRef = React.createRef();
    }

    componentWillReceiveProps(nextProps) {
        const { isActive, orderItemId } = this.props;

        // Empty state on close.
        if (!isEqual(nextProps.isActive, isActive) && nextProps.isActive === false) {
            this.setState({
                fileList: [],
                title: null,
            });
        }

        // Update orderItemId if changed
        if (!isEqual(nextProps.orderItemId, orderItemId) && nextProps.orderItemId !== undefined) {
            this.setState({
                orderItemId: nextProps.orderItemId,
            });
        }
    }

    handleCapture(base64Image) {
        const uid = Math.random();
        const fileList = JSON.parse(JSON.stringify(this.state.fileList));

        const file = {
            uid,
            name: `screenshot-${uid}.png`,
            url: base64Image,
        };

        fileList.push(file);

        this.setState({
            fileList,
            isInnerModelActive: false,
        });
    }

    handleCloseInnerModal() {
        this.setState({ isInnerModelActive: false });
    }

    handleOpenInnerModal() {
        this.setState({ isInnerModelActive: true });
    }

    handleUpload(file) {
        let fileName = file.name;

        // Browser globals are available in this context
        /* eslint-disable no-undef */
        const reader = new window.FileReader();
        /* eslint-enable no-undef */

        let splitString = fileName.split('.');
        splitString = splitString.map(str => str.replace(/[^a-zA-Z0-9]/g, '').toLowerCase());
        fileName = splitString.join('.');

        reader.onload = (e) => {
            const fileList = JSON.parse(JSON.stringify(this.state.fileList));
            const base64Image = e.target.result;

            const uploadFile = {
                uid: Math.random(),
                name: fileName,
                url: base64Image,
            };

            fileList.push(uploadFile);

            this.setState({ fileList });
        };

        reader.readAsDataURL(file);

        return false;
    }

    handleRemove(uid) {
        let fileList = JSON.parse(JSON.stringify(this.state.fileList));
        fileList = fileList.filter(file => file.uid !== uid);
        this.setState({ fileList });
    }

    handleSubmit() {
        const { customer, actions, onClose } = this.props;
        const { fileList, title, orderItemId } = this.state;
        const customerId = customer && customer.id;

        if (!fileList.every(file => file.name && file.url) || (!title || title === '')) {
            notification.error({ message: 'Error detected', description: 'One or more required inputs were not provided.' });
        // } else if (!fileList.every((file) => {
        //     const splitString = file.name.split('.');
        //     return ['png', 'jpeg', 'jpg'].includes(splitString[splitString.length - 1]);
        // })) {
        //     notification.error({ message: 'Error detected', description: 'One or more files were not of the right type (png, jpeg, jpg).' });
        } else {
            actions.uploadPrescriptionRequest({
                customerId,
                fileList,
                title,
                orderItemId,
            });
            this.setState({
                fileList: [],
                title: null,
            });
            // Close the modal after submission
            onClose();
        }
    }

    render() {
        const { isActive, onClose } = this.props;
        const { fileList, title, isInnerModelActive } = this.state;

        return (
            <Modal
                className="upload_script_modal"
                visible={isActive}
                onCancel={() => onClose(true)}
                title={<div
                    style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center'
                    }}>
                    <p style={styles.text1}>Upload New Script</p>
                </div>}
                footer={<div
                    style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center'
                    }}>
                    <Button
                        onClick={() => this.handleSubmit()}
                        style={{ ...styles.searchBarButton, ...styles.text2, color: 'white', }}>Submit</Button>
                </div>}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '90%',
                        }}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                            }}>
                            <p style={{ ...styles.text2, marginTop: 10, marginBottom: 10, }}>Title:</p>
                            <div>
                                <Input
                                    value={title}
                                    onChange={event => this.setState({ title: event.target.value, })}
                                    style={{ ...styles.text4, height: 24, }} />
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                                marginTop: 10,
                            }}>
                            <p style={{ ...styles.text2, marginTop: 10, marginBottom: 10, }}>
                                File:</p>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    width: '100%',
                                }}>
                                <Input
                                    value={isArray(fileList) && fileList[fileList.length - 1] && fileList[fileList.length - 1].name}
                                    style={{ ...styles.text4, height: 24, }} />
                                <Upload
                                    beforeUpload={file => this.handleUpload(file)}
                                    multiple={false}
                                    showUploadList={false}
                                    style={{ flex: 1, }}>
                                    <Button style={{ ...styles.text3, height: 24, }}>Click to Upload</Button>
                                </Upload>
                            </div>
                        </div>
                        <p style={{ ...styles.text3, marginTop: 20, marginBottom: 10, }}>or</p>
                        <div
                            onClick={() => this.handleOpenInnerModal()}
                            style={styles.buttonWrapper}>
                            <AntdIcon type="camera" theme="filled" style={{ fontSize: '150%' }} />
                            <p style={styles.text3}>Camera</p>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%',
                                marginTop: 10,
                            }}>
                            <p style={{ ...styles.text2, marginTop: 10, marginBottom: 10, }}>Preview:</p>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    width: '100%',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%', }}>
                                    {
                                        !isEmpty(this.state.fileList) ?
                                            <Carousel>
                                                {(fileList.map(file => (<Upload
                                                    key={file.url}
                                                    onPreview={() => {
                                                        /* eslint-disable no-undef */
                                                        const image = new window.Image();
                                                        image.src = file.url;
                                                        const w = window.open('');
                                                        w.document.write(image.outerHTML);
                                                        /* eslint-enable no-undef */
                                                    }}
                                                    onRemove={() => this.handleRemove(file.uid)}
                                                    multiple={false}
                                                    listType="picture-card"
                                                    fileList={[file]} />)))}
                                            </Carousel>
                                            :
                                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={'No image'} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ImageCapture
                    isActive={isInnerModelActive}
                    onCapture={this.handleCapture.bind(this)}
                    onClose={this.handleCloseInnerModal.bind(this)} />
            </Modal>
        );
    }
}

UploadModal.defaultProps = {
    isActive: false,
    onClose: () => { },
    actions: {},
    orderItemId: null,
};

UploadModal.propTypes = {
    isActive: PropTypes.bool,
    onClose: PropTypes.func,
    actions: PropTypes.object,
    customer: PropTypes.object.isRequired,
    orderItemId: PropTypes.number,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        customer: state.customer.customer,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...customerActions,
        }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadModal);
